import React, { useEffect } from 'react';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        jQuery: any;
    }
}

export const App = ({ children }: { children: React.ReactNode }) => {
    useEffect(() => {
        try {
            if (window.frameElement && window.top) {
                window.top.location.replace(window.location.href);
                return;
            }
        } catch (e) {
            console.error('Redirection error:', e);
        }
    }, []);

    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};
